import { CaArea, CaResult } from '../../core';

import { fillCaResultScores } from './fill-ca-result-scores.function';

export function resetScores(): void {
    localStorage.setItem('caResultCheckState', null);
}

export function updateScores(area: CaArea, result: CaResult | null): void {
    area.evaluatedBool = area.evaluatedBool !== true;
    if (result != null) {
        fillCaResultScores(result.groups, result);
    }
    localStorage.setItem('caResultCheckState', JSON.stringify(result ?? null));
}

export function restoreScores(result: CaResult | null): void {
    const checkState: CaResult = JSON.parse(
        localStorage.getItem('caResultCheckState'),
    );
    result?.groups?.forEach((g) => {
        const og = checkState?.groups?.find((e) => e.name === g.name);
        g.scorePercent = og?.scorePercent;
        g?.areas?.forEach((a) => {
            const oa = og?.areas?.find((e) => e.name === a.name);
            a.evaluatedBool = oa?.evaluatedBool;
        });
    });
    if (result != null) {
        result.score = checkState?.score;
        result.scorePercent = checkState?.scorePercent;
    }
}
